import { scrollIntoView as _scrollIntoView } from 'seamless-scroll-polyfill';

const defaultScrollIntoViewOptions: ScrollIntoViewOptions = {
	behavior: 'smooth',

	// This can prevent the body from scrolling in some cases.
	block: 'nearest',

	inline: 'start',
};

/**
 * Same as `scrollIntoView` from `seamless-scroll-polyfill` but this allows
 * `null` for element and provides default options.
 */
export function scrollIntoView(
	element: Element | null | undefined,
	scrollIntoViewOptions?: ScrollIntoViewOptions
) {
	if (element) {
		_scrollIntoView(element, {
			...defaultScrollIntoViewOptions,
			...scrollIntoViewOptions,
		});
	}
}
